import { render, staticRenderFns } from "./DoctorProfileReportData.vue?vue&type=template&id=bd2e5e62"
import script from "./DoctorProfileReportData.vue?vue&type=script&lang=js"
export * from "./DoctorProfileReportData.vue?vue&type=script&lang=js"
import style0 from "./DoctorProfileReportData.vue?vue&type=style&index=0&id=bd2e5e62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports